import DialogRef from '@/components/common/DialogRef';
import DynamicImage from '@/components/DynamicImage';

const QrcodeDialog = ({ children }: { children: React.ReactNode }) => {
  return (
    <DialogRef
      title=""
      trigger={children}
      contentClass={'w-[70vw] p-[32px]'}
      footer={
        <p className="text-center">
          立即扫码咨询<br></br>获取免费试用名额
        </p>
      }
    >
      <div className="flex w-full justify-center">
        <DynamicImage
          src="https://osscdn.weiyouzhihui.com/mall/goods/1758599699501/0%5B1%5D.png"
          width={250}
          height={250}
          alt="微友智汇二维码"
        ></DynamicImage>
      </div>
    </DialogRef>
  );
};

export default QrcodeDialog;
